import React from "react";
import styled from "styled-components";

import Navbar from "../components/Navbar/Navbar";
import { useLocation } from "react-router-dom";

const Container = styled.div``;

const Success = () => {
  const location = useLocation();
  console.log(location);

  return (
    <Container>
      <Navbar />
      success!!
    </Container>
  );
};

export default Success;
